module.exports = __webpack_public_path__ + "img/9788931006629.3516fa1a.jpg";